export class Entidade {
	id?: number;
	_links?: any;
}
